import { ErrorApiCodes } from '@src/context/Shared/domain/ErrorApiCodes.type'
import { SourceCodes } from '@src/context/Shared/domain/ErrorSourceCodes.type'

export interface ErrorApi {
  errorCode: ErrorApiCodes
  defaultMessage: string
  source: SourceCodes
  message: string
  requestId?: string | null
}

export function isErrorApi(error: unknown): error is ErrorApi | Array<ErrorApi> {
  if (Array.isArray(error)) {
    return error.every((er) => isErrorApi(er))
  } else {
    return (
      typeof error === 'object' &&
      error !== null &&
      'message' in error &&
      'defaultMessage' in error &&
      'errorCode' in error &&
      'source' in error &&
      typeof (error as ErrorApi).message === 'string' &&
      typeof (error as ErrorApi).defaultMessage === 'string' &&
      Object.values(ErrorApiCodes).includes((error as ErrorApi).errorCode) &&
      Object.values(SourceCodes).includes((error as ErrorApi).source)
    )
  }
}
